<template>
    <div>
    <div id="opa">
		<div id="toppage"> 
			<div class="title"> {{ maintitle }} </div>
			<div class="dokpz_left">
				<div class="title_left">{{ title }} {{ nazwaNosnik }}</div>
				<div class="items">
						<ejs-grid ref="grid" :dataSource="data" :onCreated="onCreated" :allowPaging="true" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected='rowSelected' :rowDeselected="rowSelected"> 
						<e-columns>
							<e-column field='ID' headerText='ID' :visible="false"></e-column>
							<e-column field='ID_MAGAZYNU' headerText='Id magazynu' :visible="false"></e-column>
							<e-column field='Typ_skrzyni' headerText='Typ Skrzyni' width='200'></e-column>
							<e-column field='Waga_skrzyni' headerText='Waga' width='100'></e-column>
							<e-column field='Opis_skrzyni' headerText='Opis' width='200'></e-column>
									<!--<e-column type='checkbox' width='50'></e-column>-->
						</e-columns>
					</ejs-grid>
				</div>
			</div>
			<div class="dokpz_right2 wybor">
				<div >
					<div class="wrap">
									<label>ILOŚĆ NOŚNIKA</label>
									<ejs-numerictextbox format="###" :min="0" :value="this.iloscnosnika" cssClass="e-style" @change="changeNum"></ejs-numerictextbox>
							</div>
							<div class='wrap'>
									<label>SUGEROWANA WAGA NOŚNIKA</label>
									<ejs-numerictextbox ref="noswaga" :value="this.noswaga" format="###" :min="0" cssClass="e-style" v-on:change="setValueNos($event)"></ejs-numerictextbox>
							</div>
				</div>
			</div>
		</div>
		<div class="separator"/>
		<div id="bottompage">
			<div class="dokpz_left ">
				<div class="title_left">{{ title2 }} {{ nazwaOpakowanie }}</div>
				<span class="allopak" v-on:click="allopakclick()">(pokaż wszystkie)</span>
				<div class="items">
						<ejs-grid ref="grid2" :dataSource="data2" :allowPaging="true" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected='rowSelected2' :rowDeselected="rowSelected2"> 
						<e-columns>
							<e-column field='ID' headerText='ID' :visible="false"></e-column>
							<e-column field='ID_MAGAZYNU' headerText='Id magazynu' :visible="false"></e-column>
							<e-column field='Typ_skrzyni' headerText='Typ Skrzyni' width='200'></e-column>
							<e-column field='Waga_skrzyni' headerText='Waga' width='100'></e-column>
							<e-column field='Opis_skrzyni' headerText='Opis' width='200'></e-column>
						</e-columns>
					</ejs-grid>
				</div>
				<div >

				</div>
			</div>
			<div class="dokpz_right2">
				<div>
					<div class="wrap">
						<label>ILOŚĆ OPAKOWAŃ</label>
						<ejs-numerictextbox ref="ilopak" :value="ilopak" format="###" :min="0" cssClass="e-style" @change="changeNum2"></ejs-numerictextbox>
					</div>
					<div class='wrap'>
						<label>SUMA OPAKOWAŃ</label>
						<ejs-numerictextbox ref="sumaopak" :value="sumaopak" format="###" :min="0" cssClass="e-style"></ejs-numerictextbox>
					</div>
					<div class='wrap'>
						<label>NADWYŻKA (kg)</label>
						<ejs-numerictextbox ref="nadwyzka" :value="nadwyzka" format="###" :min="0" cssClass="e-style" @change="changeNum3"></ejs-numerictextbox>
					</div>
				</div>
			</div>
			<div class="wbottom"><hr/></div>
			<div class="dokpz_left bottompage">
				<div class="wleft2">
						<button class="wlabel wrocbtn2" @click="this.wrocmenuclick"> WRÓĆ DO MENU</button>
				</div>
				<div class="wleft">
						<button class="wlabel wrocbtn" @click="this.wrocclick"> WRÓĆ </button>
				</div>
				<div class="wrfit wsize">
					<div>
								<label>Obliczona waga kontrolna</label><br/>
									<input type="text" disabled="true" :value="this.obliczonaWagaCalkowita"/>
					</div>
					<div class="bsecond">
								<label>Obliczona waga towaru netto</label><br/>
									<input type="text" disabled="true" :value="this.obliczonaWagaTowaru"/>
					</div>
				</div>
			</div>
			<div class="dokpz_right2 bottompage">
				<div class="wlfit wsize">
					<div>
						<label>Wynik ważenia</label><br/>
						<input type="text" disabled="true" :value="wagaval"/>
					</div>
					<div class="bsecond">
						<label><strong>Waga towaru netto</strong></label><br/>
						<input class="finalweight" type="number" :value="this.wagaTowaru" v-on:change="setValue($event)"/>
					</div>
				</div>
				<div class="wrfit">
					<div class="wrfit">
						<button class="wlabel wagaprzycisk"> SPRAWDŹ WAGĘ </button>
					</div>
					<div class="separator"/>
					<div>
						<button class="wlabel przyjmij"> PRZYJMIJ </button>
					</div>
				</div>
			</div>
		</div>
		<div id="testpage">
		<!-- <div class="separator"/> -->
		<div class="cokolwiek"></div>
		</div>
    </div>
  </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
import { opakowanie_dane } from "./opakowanie_dane.js";
import Skrzynia from "@/components/Skrzynia";
import * as CONFIG from "./config.js";
import axios from "axios";
import VueSSE from 'vue-sse';
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);
Vue.use(Skrzynia);
Vue.use(VueSSE);

export default {
  name: "opakowanie",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	data2: [],
	data: [],
	urlArt: "/agent/GALEK.Magazyn/GetArtykulByIdZlecenia/",
	urlCheckWeight: "/agent/GALEK.Magazyn/GetSkrzyniaWeight/",
	urlPost: "/agent/GALEK.Magazyn/PrzyjmijDokPW/",
	url3: "/agent/GALEK.Magazyn/GetRodzajeSkrzynByIdZlecenia",
	url2: "/agent/GALEK.Magazyn/GetRodzajeSkrzyn",
	url: "/agent/GALEK.Magazyn/GetNosnik",
	maintitle: "PRZYJĘCIE WYROBU GOTOWEGO > ZLECENIA > LISTA DOKUMENTÓW PZ > przyjęcie",
	title2: "Opakowanie:",
	title: "Nośnik:",
	show: true,
	show2: true,
        pageSettings: { pageSize: 3 },
        selectionOptions: { allowColumnSelection: false, type: 'Single' },
	whereto: "",

	czywaga: true,
	czywaga2: true,
	mag: "",
	backto: "",
	jwt: "",
	skr: 0,
	curwaga: 0,
	noswaga: 0,
	selectednosnik: 1,
	iloscnosnika: 0,
	id_nosnika: 0,
	id_opakowania: 0,
	ilopak: 0,
	sumaopak: 0,
	nadwyzka: 0,
	id_artykulu: 0,
	nazwa_art: "",
	wagaTowaru:0,
	requestBody: {},
	wynikWazenia: 0,
	obliczonaWagaCalkowita: 0,
	obliczonaWagaTowaru: 0,
	jednostkaPrzyjecia: false,
	tempWaga: {},
	dokumenty: "",
	currentti:"",
	nazwaNosnik: "Nie wybrano",
	nazwaOpakowanie: "Nie wybrano",
	id_uzytkownika: -1,
        sse: null,
        wagaval: 0,
   }),
   provide: {
	grid: [Page, Sort, Filter, Group]
   },
   watch: {
	obliczonaWagaTowaru(){
		if(this.wagaTowaru === 0)
			this.wagaTowaru = this.obliczonaWagaTowaru

	},
   },
   methods: { 
	getArtykul() {
		return axios
			.get(CONFIG.API_URL + this.urlArt + this.id_zlecenia, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
			}
			})
			.then(response => {
				return response.data;
			})
			.catch(e => {
				alert("ERROR" + e);
			});
	},
	onCreated(){
		if (this.selectednosnik !==0){
			console.log(this.selectednosnik)
			this.$refs.grid.selectRow([1], true);
	}
	},
	setValueNos(e){
		this.noswaga = e.value
	},
	setValue(e){
		this.wagaTowaru = e.target.value
	},
	dowagiclick() {
		this.sse.disconnect();

		this.currentto = "?prev=nosnikopakowanie";
		var id_dok_mag = "";
		var id_zlecenia = "";

		var prev = "";
		var params = this.$route.query;
		if (params["mag"]) {
	     		id_dok_mag = params["mag"];
	     		this.currentto += "&mag=" + id_dok_mag;
		}
		if (params["prev"]) {
				prev = params["prev"];
	     		this.currentto += "&prev=" + prev;
		}
		if (params["id_zlecenia"]) {
	     		id_zlecenia = params["id_zlecenia"];
	     		this.currentto += "&id_zlecenia=" + id_zlecenia;
		}


		this.requestBody = {
			id_uzytkownika: this.id_uzytkownika,
			id_artykulu: this.id_artykulu,
			ilosc: this.sumaopak,
			idZlecenia: this.id_zlecenia,
			wagaTowaru: this.wagaTowaru,
			jednostkaPrzyjecia: this.jednostkaPrzyjecia,
			dokumenty: this.dokumenty,
			id_nosnika: this.id_nosnika,
			ilosc_nosnika: this.iloscnosnika
		}
		if(this.id_nosnika !== 0){
			this.postData().then(data => {
			if(data.blad !== "0")
				this.$router.push({ path: "/potwierdzenieerror" + this.currentto + "&prev2=" + this.backto + "&error=" + data.blad});
			else
				this.$router.push({ path: "/potwierdzenieok" + this.currentto + "&prev2=" + this.backto + "&iddokmag=" + data.id_dok + "&iloscnosnika=" + this.iloscnosnika + "&noswaga=" + this.noswaga + "&ilopak=" + this.ilopak + "&sumaopak=" + this.sumaopak + "&nadwyzka=" + this.nadwyzka + "&id_nosnika=" + this.id_nosnika + "&id_opakowania=" + this.id_opakowania });
		});
		}


	},
	sprawdzwage(){
		this.sse.disconnect();
		var that = this;
		this.getCheckWeight().then(data => {
			that.tempWaga = data
			that.obliczonaWagaCalkowita = that.tempWaga[0].wagaCalkowita,
			that.obliczonaWagaTowaru = that.tempWaga[0].wagaTowaru,
			that.jednostkaPrzyjecia = that.tempWaga[0].jednostkaPrzyjecia
		})
		
	},

	wrocclick() {
		this.sse.disconnect();
		this.$router.push({ path: "" + this.backto });
	},

	wrocmenuclick() {
		this.sse.disconnect();
		this.$router.push({ path: "main" });
	},
	allopakclick() {
		var that = this;
		this.getData2().then(data => {
                        that.data2 = data;
                });
	},
	rowSelected2(args) {
    		let selectedrowindex = this.$refs.grid2.getSelectedRowIndexes();  // Get the selected row indexes.
    		//alert(selectedrowindex); // To alert the selected row indexes.
    		let selectedrecords = this.$refs.grid2.getSelectedRecords();  // Get the selected records.
		//alert(selectedrecords);
		//this.selectSkrzynia(selectedrowindex);

		if (selectedrowindex != null && selectedrowindex.length > 0) {
			this.show2 = true;
			this.czywaga2 = true;
			this.id_opakowania = selectedrecords[0].ID;
			console.log(this.data2)
			const opakowanie = this.data2.find(d => d.ID == this.id_opakowania )
			this.nazwaOpakowanie = opakowanie.Typ_skrzyni


		} else {
			this.id_opakowania = 0
			this.show2 = false;
			this.czywaga2 = false;
			this.nazwaOpakowanie = "Nie wybrano"
		}

		
	},
	rowSelected(args) {
    		let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
    		//alert(selectedrowindex); // To alert the selected row indexes.
    		let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		//this.selectSkrzynia(selectedrowindex);

		if (selectedrowindex != null && selectedrowindex.length > 0) {
			this.show = true;
			this.czywaga = true;
			this.curwaga = selectedrecords[0].Waga_skrzyni;
			this.id_nosnika = selectedrecords[0].ID;
			const nosnik = this.data.find(d => d.ID == this.id_nosnika )
			this.nazwaNosnik = nosnik.Typ_skrzyni
		} else {
			this.id_nosnika=0
			this.show = false;
			this.czywaga = false;
			this.nazwaNosnik = "Nie wybrano"
		}
	},
	selectSkrzynia(val1) {
		this.$root.$emit("update:skrzynia", val1);
	},
	selectSkr(val1) {
		this.skr = Number(val1);
	},
	getCheckWeight(){
		return axios
			.get(CONFIG.API_URL + this.urlCheckWeight + "/" + this.id_zlecenia + "/" + this.id_artykulu + "/" + this.id_nosnika + "/" + this.iloscnosnika + "/" + this.noswaga + "/" + this.id_opakowania + "/" + this.ilopak + "/" + this.sumaopak + "/" + this.nadwyzka + "/" + this.wagaval , {
			headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"Accept": "application/json",
					"Authorization": "Bearer " +  this.jwt,
			}
			})
			.then(response => {
					return response.data;
			})
			.catch(e => {
					alert("ERROR" + e);
			});
	},
	postData() {
		 return axios
                .post(CONFIG.API_URL + this.urlPost + this.id_uzytkownika, 
                this.requestBody,
                {
                    headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Accept": "application/json",
                    		"Authorization": "Bearer " +  this.jwt,
                    }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
	},
	getData() {
                return axios
                        .get(CONFIG.API_URL + this.url, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
	getData2() {
                return axios
                        .get(CONFIG.API_URL + this.url2, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
	getData3() {
                return axios
                        .get(CONFIG.API_URL + this.url3 + "/" + this.id_zlecenia, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
	changeNum(val) {
		console.log('val ' + val.value + ' ' + this.iloscnosnika)
		if(val.value != this.iloscnosnika){
			var nval = val.value;
			this.iloscnosnika = nval
			this.noswaga = this.curwaga * nval;
		}
	},
	changeNum2(val) {
		var nval = Number(val.value);
		this.ilopak = nval;
		this.sumaopak = nval + this.getNadwyzka();
	},
	changeNum3(val) {
		var nval = Number(val.value);
		this.nadwyzka = nval;
		this.refreshOpak();
	},
	refreshOpak() {
		this.sumaopak = this.ilopak + this.getNadwyzka();
	},
	getNadwyzka() {
		var nadwyzka = 0;
		if (this.nadwyzka > 0) {
			nadwyzka = 1;
		}
		return nadwyzka;
	},
   },
   mounted() {
	var params = this.$route.query;
        var prev = "";
	var id_dok_mag = "";
	var id_zlecenia;
	if(params["iloscnosnika"]){
			this.iloscnosnika = params["iloscnosnika"]
	}
	if(params["noswaga"]){
		this.noswaga = params["noswaga"]
	}
	if (params["ilopak"]){
		this.ilopak = params["ilopak"]
	}
	if (params["sumaopak"]){
		this.sumaopak = params["sumaopak"]
	}
	if (params["nadwyzka"]){
		this.nadwyzka = params["nadwyzka"]
	}
	if (params["id_nosnika"]){
		this.id_nosnika = params["id_nosnika"]
	}
	if (params["id_opakowania"]){
		this.id_opakowania = params["id_opakowania"]
	}

	if (params["mag"]) {
		id_dok_mag = params["mag"];
		this.mag = "/" + id_dok_mag;
		this.dokumenty = id_dok_mag;
	}
	if (params["id_zlecenia"]) {
		id_zlecenia = params["id_zlecenia"];
		this.id_zlecenia = id_zlecenia;
	}
        if (params["prev"]) {
             prev = params["prev"];
	     this.whereto = "?prev=nosnikopakowanie&mag=" + id_dok_mag + "&id_zlecenia=" + id_zlecenia + "&prev2=dokumentpzprzyjecie";
	     if (prev.indexOf("dokumentpzprzyjecie") != -1) {
		//this.title = "Panel główny > Zlecenia > LISTA DOKUMENTÓW PZ > Opakowanie";
		this.backto = "/dokumentpzprzyjecie?id_zlecenia=" + id_zlecenia;
	     } else {
		//this.title = "Panel główny > ODPADY > Opakowanie";
		this.backto = "/odpady";
	     }
        }
	var that = this;
        Storage.loadJWT("jwt").then(resp => {
                that.jwt = resp.access_token;
		that.id_uzytkownika = resp.user_id;
		//nosniki
                that.getData().then(data => {
                        that.data = data;
						if(that.id_nosnika !== 0) {
							const nosnik = data.find(d => d.ID == that.id_nosnika )
							this.nazwaNosnik = nosnik.Typ_skrzyni
							this.curwaga = nosnik.Waga_skrzyni
						}
                });
		//opakowania
                that.getData3().then(data => {
                        that.data2 = data;
						if(that.id_opakowania !== 0) {
							const opakowanie = data.find(d => d.ID == that.id_opakowania )
							this.nazwaOpakowanie = opakowanie.Typ_skrzyni
						}
                });
				that.getArtykul().then(data => {
					that.nazwa_art = data[0].NAZWA
					that.maintitle = "PRZYJĘCIE WYROBU GOTOWEGO > ZLECENIA > LISTA DOKUMENTÓW PZ > Przyjęcie " + that.nazwa_art
				})
        });
	document.querySelector(".przyjmij").addEventListener('click', function() { that.dowagiclick(); } );
	document.querySelector(".wagaprzycisk").addEventListener('click', function() { that.sprawdzwage(); } );
	document.querySelector(".wrocbtn").addEventListener('click', function() { that.wrocclick(); } );
	document.querySelector(".wrocbtn2").addEventListener('click', function() { that.wrocmenuclick(); } );

	this.sse = this.$sse.create(CONFIG.WAGA_URL);
        this.sse.on('message', (msg) => console.log('Message:' + msg))
                .on('wazenie', (msg) => { console.log('Message:' + msg); var json = JSON.parse(msg); var rand = Math.random() * 10; that.wagaval = json.masa; }) 
                .on('error', (err) => console.log('Failed to parse or lost connection:' + err))
                .connect()
                .catch((err) => console.log('Failed make initial connection:' + err));

	//document.querySelector(".allopak").addEventListener('click', function() { that.allopakclick(); } );

	/*document.querySelector(".do_wagi1").addEventListener('click', function() { that.selectSkr('1'); } );
	document.querySelector(".do_wagi2").addEventListener('click', function() { that.selectSkr('2'); } );
	document.querySelector(".do_wagi3").addEventListener('click', function() { that.selectSkr('3'); } );*/
   },
   components: {
	Skrzynia,
        "ejs-numerictextbox": NumericTextBoxComponent,
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.wrap {
margin: 3% auto;
width: 240px;
}
.separator {
   clear: both;
   width: 100%;
   height: 20px;
   margin: 1% 1% 1% 1%;
}
.e-numeric.e-style .e-control.e-numerictextbox {
        color: royalblue;
        font-size: xx-large;
        border: 0px;
    }

/* csslint ignore:start */
    .e-numeric .e-input-group-icon.e-spin-up:before {
        content: "\e823";
        color: rgba(0, 0, 0, 0.54);
    }

    .e-numeric .e-input-group-icon.e-spin-down:before {
        content: "\e934";
        color: rgba(0, 0, 0, 0.54);
    }


.do_wagi {
        width: 100px;
        height: 50px;
}

.do_wagi1,.do_wagi2,.do_wagi3 {
        width: 50px;
        height: 50px;
	margin-right: 20px;
}

.title, .title_left {
        text-align: left;
        width: 100%;
}

.items {
        float:none;
}
.dokpz_left {
        float: left;
        width: 50%;
        padding: 0% 2% 0% 2%;

}
.dokpz_right {
        padding: 10% 2% 0% 2%;
}
.dokpz_right2 {
        padding: 0% 2% 0% 2%;
		height: 150px;

}
.dokpz_right,.dokpz_right2 {
        float:left;
        width: 40%;
}
.dokpz_right2.wybor{
		margin-top: 20px;
}
.dokpz_bottom {
        clear:both;
        width: 100%;
        padding: 2% 2% 0% 2%;
}
.wright {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wleft2 {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 80px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {	
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
.wbottom {
	clear:both;
	padding-top: 10px;
}
.wlfit {
	float:left;
	padding-right:3px;
	height:30px;
}
.wsize {
	width: 220px;
}
.wsize input {
	height: 50px;
	width: 120px;
	color: red;
	font-size: xx-large;
	margin-top: 10px;
}
.wrfit {
	float:right;
}
.allopak {
	display:inline;
	width:100px;
	height:20px;
	color:blue;
	cursor: pointer;
}
.bsecond {
	margin-top:10px;
}

#bottompage{

}
.wrocbtn{
	position:fixed;
	bottom: 10px;

}
.wrocbtn2{
	position:fixed;
	bottom: 80px;

}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.finalweight{
	border: 2px solid black;
}
.wlabel.przyjmij{
	position:fixed;
	bottom: 10px;
	right: 10px;
}
.wlabel.wagaprzycisk{
	position:fixed;
	right: 10px;
	bottom: 150px;
}
.dokpz_right2.bottompage,
.dokpz_left.bottompage{
	margin-top: 10px;
}

hr{
	margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/NosnikOpakowanie.vue